<template>
  <div class="not-found">
    <div class="not-found__container">
      <div class="not-found__image">
        <img
          svg-inline
          src="../../../static/images/404.svg"
          alt="404 Not found"
        >
      </div>
      <div class="not-found__information">
        <div class="not-found__img">
          <img
            svg-inline
            src="../../../static/images/logo-out-line.svg"
            alt="Logo"
          >
        </div>
        <div class="content">
          <div class="information-text">
            <span> Ops! Não conseguimos encontrar essa página :( </span>
          </div>
          <div class="not-found__actions">
            <div class="title">
              <span> Para onde você queria ir? </span>
            </div>
            <div class="content">
              <ul class="items">
                <li
                  v-if="toggle.manualServiceOrderRegistration"
                  class="item"
                  @click="goTo('orders/new', 'Cadastrar manualmente')"
                >
                  Cadastrar Manuamente
                </li>
                <li
                  v-if="toggle.serviceOrderList"
                  class="item"
                  @click="goTo('orders', 'Listagem de OS')"
                >
                  Listagem de OS
                </li>
                <li
                  v-if="toggle.tagPrint"
                  class="item"
                  @click="goTo('print-tag/samples', 'Impressão de etiquetas')"
                >
                  Impressão de etiquetas
                </li>
              </ul>
              <button
                class="btn-primary button-back"
                @click="goTo('dashboard', 'Página inicial')"
              >
                Ir para a página inicial
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="not-found__phone-support">
      <span class="title"> Está com dúvidas? </span>
      <span class="text"> Obtenha suporte pelo telefone 0800-643-8100 - opção 1. </span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Notfound',
  computed: {
    ...mapGetters(['toggle'])
  },
  methods: {
    goTo(where, action) {
      this.$router.replace('/' + where)
      this.submitAnalyticsEvent(action)
    },
    submitAnalyticsEvent(action) {
      this.$analytics.pushAnalyticsEvent('ga-event', {
        category: '404 - Página não encontrada',
        action: 'Voltar para: ' + action,
        'id-user': this.profile.id,
        'id-lab': this.profile.id_laboratory,
        'name-lab': this.profile.laboratoryName
      })
    }
  }
}
</script>

<style lang="scss">
@import '../../../static/stylesheets/variables';

.not-found {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-left: 20px;

  &__container {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__information {
    margin-left: 42px;

    .content {
      margin-top: 28px;
    }

    .information-text {
      font-family: Roboto, sans-serif;
      font-size: 36px;
      line-height: 48px;
      color: #7a7a7a;
      max-width: 445px;
    }
  }

  &__actions {
    margin-top: 28px;

    .title {
      span {
        display: inline-block;
        font-family: Roboto, sans-serif;
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        color: #7a7a7a;
      }
    }

    .content {
      margin-top: 20px;
    }

    .items {
      position: relative;

      &::before {
        position: absolute;
        top: 0;
        left: 0;
        content: '';
        width: 2px;
        height: 100%;
        background: #e2245a;
      }
    }

    .item {
      margin-left: 25px;
      font-family: Roboto, sans-serif;
      font-size: 14px;
      line-height: 16px;
      color: #7f1a54;
      cursor: pointer;

      &:hover {
        text-decoration: underline;
      }
    }

    .button-back {
      margin-top: 58px;
      display: flex;
      align-items: center;
      padding: 12px 32px;
      background: #7f1a54;
      border-radius: 3px;
      font-family: Roboto, sans-serif;
      font-weight: 500;
      font-size: 12px;
      line-height: 14px;
      letter-spacing: 0.8px;
      text-transform: uppercase;
      color: #ffffff;
    }
  }

  &__image {
    margin-top: 72px;
  }

  &__phone-support {
    display: flex;

    .title {
      display: inline-block;
      color: #7f1a54;
      font-weight: 500;
    }

    .text {
      display: inline-block;
      color: #7a7a7a;
      margin-left: 8px;
    }
  }
}
</style>
